export default __webpack_public_path__ + "static/media/wotfard-semibold-webfont.5a44d1fe.woff2";